import { z } from 'zod';

/**
 * Internal Queue message — docs/00_TECHNICAL_ARCHITECTURE_v1.2.md §20.
 *
 * Deliberately absent: the Turnstile token (AGENTS.md invariant 3; it has
 * already been verified by the time the message is built) and the normalized
 * search fields (the consumer recomputes them with the shared normalization
 * utility so there is a single implementation).
 */
export const CHECKIN_MESSAGE_VERSION = 1;

export const CheckinMessageSchema = z.strictObject({
  version: z.literal(CHECKIN_MESSAGE_VERSION),
  submissionId: z.uuid(),
  eventId: z.string().min(1).max(100),
  eventConfigVersion: z.int().min(1),
  locationId: z.string().min(1).max(100),
  fullName: z.string().min(1).max(150),
  phone: z.string().max(30).optional(),
  email: z.email().max(254).optional(),
  payload: z.record(z.string(), z.unknown()).optional(),
  clientCreatedAt: z.iso.datetime({ offset: true }),
  receivedAt: z.iso.datetime({ offset: true }),
});

export type CheckinMessage = z.infer<typeof CheckinMessageSchema>;

/**
 * Check-out messages carry a `kind` discriminator; check-in messages do not
 * and never will. The consumer tries this schema first and falls back to
 * `CheckinMessageSchema`, so messages already in flight during a deploy keep
 * working — which is what makes deploying the consumer before the API safe,
 * and the reverse order unsafe.
 */
export const CHECKOUT_MESSAGE_VERSION = 1;

export const CheckoutMessageSchema = z.strictObject({
  kind: z.literal('checkout'),
  version: z.literal(CHECKOUT_MESSAGE_VERSION),
  submissionId: z.uuid(),
  eventId: z.string().min(1).max(100),
  clientCheckedOutAt: z.iso.datetime({ offset: true }),
  receivedAt: z.iso.datetime({ offset: true }),
});

export type CheckoutMessage = z.infer<typeof CheckoutMessageSchema>;
